<template>
  <div class="comment_right">
    <div class="news_head">
      <h3>推荐企业</h3>
      <div class="fdc" @click="reload">
        <img class="icon" src="../assets/images/break.png" alt="" />
        <span class="ml-10">换一批</span>
      </div>
    </div>
    <div class="news_coment mt-10">
      <div class="news_mant" @click="toDetail(item)" v-for="(item, index) in list" :key="index">
        <!-- <div
          class="mant_box"
          :style="{ backgroundImage: `url(${item.headUrl})` }"
        >
        <img :src="item.headUrl" alt="">
        </div> -->
        <div class="mant_box">
          <img :src="item.headUrl" alt="">
        </div>
        <p>{{item.name}}</p>
      </div>
    </div>
  </div>
</template>
<script>
import {routerGoNewpage} from "@/utils/index"
export default {
  props: {
    list: {
      type: Array,
    },
  },
  methods:{
      reload(){
          this.$emit("reload")
      },
      toDetail(item){
        sessionStorage.setItem("corporateId",item.userId);
        routerGoNewpage("/corporate_detail",{id:item.userId})
      }
  }
};
</script>
<style scoped lang="less">
.comment_right {
  background: #f8f8f8;
  border-top: 2px solid #9ad02a;
  // padding: 16px;
  padding-bottom: 6px;
}
.news_head {
  padding: 10px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .fdc{
      cursor: pointer;
  }
}
.news_coment{
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  padding: 10px 16px;
}
.news_mant {
  width: 46%;
  height: 140px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  cursor: pointer;
  margin-right:10px;
  margin-bottom: 15px;
  p{
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      word-break: break-all;
  }
}
.mant_box {
  height: 138px;
  background: #ffffff;
  // border: 1px solid red;
  // display: flex;
  // justify-content:center;
  // align-items: center;
  // vertical-align: middle;
  // background-position: center;
  // background-size: cover;
   overflow: hidden;
}
.mant_box img{
  width: 100%;
  height: 100%;
}
.news_mant p {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  margin-top: 6px;
}
.mt-10 {
  margin-top: 10px;
}
.ml-10 {
  margin-left: 10px;
}
.icon{
  width: 17px;
  height: 17px;
}
</style>


// WEBPACK FOOTER //
// src/common/newRecommImg.vue